import { ClientSettings, IClientSettings, IClientSettingsService } from "@shared/mirage/services/IClientSettingsService";
import { BaseApiService } from "./BaseApiService";
export class ClientSettingsService extends BaseApiService implements IClientSettingsService {
    private _appName = "";
    private _settings: IClientSettings = {} as IClientSettings;

    private constructor() {
        super("mirage/clientsettings");
    }

    async loadSettings(appName: string): Promise<IClientSettings> {
        this._appName = appName;
        const resp = await this.httpInstance().get<ClientSettings>("/" + appName);
        if (resp.data.errorMsg) {
            console.error(resp.data.errorMsg);
        }
        this._settings = resp.data as unknown as IClientSettings;
        return this._settings as unknown as IClientSettings;
    }

    async setSettings(settings: IClientSettings) {
        this._settings = settings;
    }
    public getSettings(): IClientSettings {
        return this._settings;
    }

    public applySettings() {
        if (this._settings.HTML_TEMPLATE_TITLE) {
            document.title = this._settings.HTML_TEMPLATE_TITLE;
        }
    }

    public static _instance: ClientSettingsService;
    public static async getInstance(appName: string): Promise<ClientSettingsService> {
        if (!ClientSettingsService._instance || appName !== ClientSettingsService._instance._appName) {
            await ClientSettingsService.initializeSettings(appName);
        }
        return this._instance;
    }

    private static async initializeSettings(appName: string) {
        ClientSettingsService._instance = new ClientSettingsService();
        const settings = await ClientSettingsService._instance.loadSettings(appName);
        ClientSettingsService._instance.setSettings(settings);
    }
}
